import axios from "axios";
import { PushUrl } from "./Controllers/rest_api_config";
import Cookies from "js-cookie";

const convertedVapidKey = urlBase64ToUint8Array(
  "BCKduw-4fG0BIvoMAVQE2RmnvSFN3YlJRJE1b5hwL9tBnh80bDQ5Hmqgj5xX6zZr5JGrdRUQsLJQnepZrtjz-s8"
);

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

async function sendSubscription(subscription) {
  // console.log(subscription, "is subscription send");
  const token = await Cookies.get("token");

  axios
    .post(
      `${PushUrl}/notifications/subscribe`,
      {},
      {
        params: { data: JSON.stringify(subscription) },
        headers: { authorization: token ? `Bearer ${token}` : "" },
      }
    )
    .then((res) =>{})
    .catch((err) => console.log(err, "is error"));
}

export function subscribeUser() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then(function (registration) {
        if (!registration.pushManager) {
          console.log("Push manager unavailable.");
          return;
        }

        registration.pushManager
          .getSubscription()
          .then(function (existedSubscription) {
            if (existedSubscription === null) {
              console.log(
                "No subscription detected, make a request.",
                Notification.permission
              );
              registration.pushManager
                .subscribe({
                  applicationServerKey: convertedVapidKey,
                  userVisibleOnly: true,
                })
                .then(function (newSubscription) {
                  console.log("New subscription added.");
                  sendSubscription(newSubscription);
                })
                .catch(function (e) {
                  if (Notification.permission !== "granted") {
                    console.log("Permission was not granted.");
                  } else {
                    console.error(
                      "An error ocurred during the subscription process.",
                      e
                    );
                  }
                });
            } else {
              console.log("Existed subscription detected.");
              sendSubscription(existedSubscription);
            }
          });
      })
      .catch(function (e) {
        console.error(
          "An error ocurred during Service Worker registration.",
          e
        );
      });
  }
}
